import React from 'react';

import { TAXONOMY_TAB_VALUES } from 'common/constants/TaxonomyConstants';

import { RiskRefCardData } from '../../api/type-def';

import RiskRefTaxonomyCard from './RiskRefTaxonomyCards/RiskRefTaxonomyCard';

interface IRisksTaxonomyCardViewProps {
	tableType: string;
	data: RiskRefCardData;
	navigateToDetailPage: (
		data: RiskRefCardData,
		category: TAXONOMY_TAB_VALUES,
	) => void;
}

const RisksTaxonomyCardView = (props: IRisksTaxonomyCardViewProps) => {
	const { tableType, data, navigateToDetailPage } = props;
	const {
		PROCESSES_VALUE,
		RISKS_VALUE,
		CONTROLS_VALUE,
		OBLIGATIONS_VALUE,
		POLICIES_VALUE,
	} = TAXONOMY_TAB_VALUES;

	const navigateToDetailsPage = (data: any, category: TAXONOMY_TAB_VALUES) => {
		navigateToDetailPage(data, category);
	};

	const getProcessCard = () => (
		<RiskRefTaxonomyCard
			data={data}
			category={PROCESSES_VALUE}
			handleNavigate={() => {
				navigateToDetailsPage(data, PROCESSES_VALUE);
			}}
		/>
	);

	const getRisksCard = () => (
		<RiskRefTaxonomyCard
			data={data}
			category={RISKS_VALUE}
			handleNavigate={() => {
				navigateToDetailsPage(data, RISKS_VALUE);
			}}
		/>
	);

	const getControlsCard = () => (
		<RiskRefTaxonomyCard
			data={data}
			category={CONTROLS_VALUE}
			handleNavigate={() => {
				navigateToDetailsPage(data, CONTROLS_VALUE);
			}}
		/>
	);
	const getObligationsCard = () => (
		<RiskRefTaxonomyCard
			data={data}
			category={OBLIGATIONS_VALUE}
			handleNavigate={() => {
				navigateToDetailsPage(data, OBLIGATIONS_VALUE);
			}}
		/>
	);

	const getPoliciesCard = () => (
		<RiskRefTaxonomyCard
			data={data}
			category={POLICIES_VALUE}
			handleNavigate={() => {
				navigateToDetailsPage(data, POLICIES_VALUE);
			}}
		/>
	);

	const getCardDetails = (tableType: string) => {
		switch (tableType) {
			case PROCESSES_VALUE:
				return getProcessCard();
			case RISKS_VALUE:
				return getRisksCard();
			case CONTROLS_VALUE:
				return getControlsCard();
			case OBLIGATIONS_VALUE:
				return getObligationsCard();
			case POLICIES_VALUE:
				return getPoliciesCard();
			default:
				return getProcessCard();
		}
	};

	return (
		<div data-testid="risk-ref-taxonomy-card-view">
			{getCardDetails(tableType)}
		</div>
	);
};

export default RisksTaxonomyCardView;
